import axios from '@/plugins/axios'
function store(data) {
  return axios.post('/yacht-manufacturers', data)
    .then(response => {
      return response.data
    })
}

function update(data, id) {
  return axios.patch(`/yacht-manufacturers/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/yacht-manufacturers', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  }
}
